export const Nationalite = [
  'Francaise',
  'UnionEuropeenne',
  'EtrangerHorsUE',
] as const

export type Nationalite = typeof Nationalite[number]

export const NationaliteLibelle: {
  [key in Nationalite]: string
} = {
  Francaise: '1 - Française',
  UnionEuropeenne: '2 - Union Européenne',
  EtrangerHorsUE: '3 - Étranger hors Union Européenne',
} as const
